import NewSelectAuto from "../../tenants/NewSelectAuto";

const Reference = ({ postData, setPostData }) => {
  const data = [
    {
      id: 1,
      name: "1"
    },
    {
      id: 2,
      name: "2"
    },
    {
      id: 3,
      name: "3"
    },
     {
      id: 4,
      name: "4"
    }

  ]

  return ( 
    <>
      <div className="edit-card p-3">
        <NewSelectAuto
        label={"No of Reference(s)"}
          disabled={undefined}
          setDisabled={undefined}
          required={true}
          selected={postData?.leaseApplicationTemplateSections?.References?.requiredRange}
          setSelected={(value) => setPostData({
            ...postData,
            leaseApplicationTemplateSections: {
              ...postData.leaseApplicationTemplateSections,
              References: {
                ...postData.leaseApplicationTemplateSections.References,
                requiredRange: Number(value),
              },
            },
          })}
          setSelectedOption={undefined}
          selectedOption={undefined}
          data={data}
          title={"Wait till the data fetches"}
          type="Select  Type"
          error={false}
          setError={() => { }}
          fromContractor={true}
         
          width={"217px"}
        />
      </div>
    </>
  );
};

export default Reference;
